import classNames from 'classnames';
import styles from './progress.module.scss';

interface ProgressRingProps {
    stroke?: number;
    radius?: number;
    progress?: number;
    className?: string;
    circleStyle?: React.CSSProperties;
    strokeStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
}

const ProgressRing = ({
    stroke = 5,
    radius = 55,
    progress = 80,
    className,
    circleStyle,
    strokeStyle,
    textStyle,
}: ProgressRingProps) => {
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference + (progress / 100) * circumference;

    return (
        <div className={classNames(styles['wrapper'], className)}>
            <svg
                className={`progress-ring--border ${styles['ring']}`}
                height={radius * 2}
                width={radius * 2}
            >
                <circle
                    className={`progress-ring--stroke ${styles['stroke']}`}
                    fill="transparent"
                    strokeDasharray={
                        circumference + circumference + circumference
                    }
                    style={{ strokeDashoffset, ...strokeStyle }}
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                    clipPath="circle()"
                />
                <circle
                    className={`progress-ring--circle ${styles['circle']}`}
                    stroke="white"
                    fill="transparent"
                    strokeDasharray={circumference + ' ' + circumference}
                    style={{ strokeDashoffset, ...circleStyle }}
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                    clipPath="circle()"
                />
                <text x="52%" y="52%" style={{ ...textStyle }}>
                    {progress + '%'}
                </text>
            </svg>
        </div>
    );
};

export default ProgressRing;
